<template>
  <div class="add-box">
    <!-- 顶部导航栏区域 start-->
    <div class="header sticky">
      <span class="back-img" @click="previousPage"></span>
      <span class="page-title">大宗录入</span>
      <span class="quit" @click="islogout">退出</span>
    </div>
    <!-- 顶部导航栏区域 end-->
    <!-- 搜索区域 start -->
    <van-field
      clearable
      label-width="130px"
      placeholder=""
      v-model="searchValue"
      class="search-box"
    >
      <div slot="label">
        <div style="display: flex; padding-top: 4px">
          <select v-model="searchType" style="color: #646566">
            <option value="1">自定义编码</option>
            <option value="2">车牌号</option>
            <option value="3">进厂编号</option>
          </select>
          <span style="margin-left: 8px">：</span>
        </div>
      </div>
      <template #button>
        <van-button
          size="small"
          type="info"
          round
          :disabled="!searchValue"
          @click="getCarInfo"
        >
          查询
        </van-button>
      </template>
    </van-field>
    <!-- 搜索区域 end -->
    <!-- 录入表单区域 start -->
    <div class="form-box">
      <van-form label-width="130px" ref="typeInFormRef" @submit="onSubmit">
        <van-field
          clearable
          readonly
          label="大宗拆解物类别："
          placeholder="请选择拆解物类别"
          :rules="[{ required: true, message: '请选择拆解物类别' }]"
          v-model="typeInForm.bulkTypeName"
          @click="dismantleTypePop = true"
        >
        </van-field>
        <van-popup v-model="dismantleTypePop" position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            :columns="dismantleTypeList"
            @cancel="dismantleTypePop = false"
            @confirm="onCheckedGoods"
          />
        </van-popup>
        <van-field
          clickable
          label="进厂编号"
          placeholder="请输入进场编号"
          :rules="[{ required: true, message: '请输入进场编号' }]"
          v-model="typeInForm.end_of_lifeVehiclesId"
        >
        </van-field>
        <van-field
          clearable
          label="数量："
          placeholder="请输入数量"
          :rules="[{ required: true, message: '请输入数量' }]"
          v-model="typeInForm.num"
          v-if="countType == 2"
        />
        <van-field
          clearable
          label="重量(kg)："
          placeholder="请输入重量"
          :rules="[{ required: true, message: '请输入重量' }]"
          v-model="typeInForm.weight"
        />
        <van-field
          clearable
          label="成本单价："
          placeholder="请输入成本单价"
          :rules="[{ required: true, message: '请输入成本单价' }]"
          v-model="typeInForm.prime_cost"
        />
        <van-field
          label="拆解人："
          placeholder="请选择拆解人"
          readonly
          :rules="[{ required: true, message: '请选择拆解人' }]"
          v-model="typeInForm.dismantlerName"
          @click="personPop = true"
        >
        </van-field>
        <van-popup v-model="personPop" position="bottom">
          <van-picker
            show-toolbar
            value-key="realName"
            :columns="dismantlePersonList"
            @cancel="personPop = false"
            @confirm="onCheckedPerson"
          />
        </van-popup>
        <van-field
          label="拆解日期:"
          placeholder="请选择拆解日期"
          readonly
          :rules="[{ required: true, message: '请选择拆解日期' }]"
          v-model="typeInForm.dismantleStartTime"
          @click="showPicTime = true"
        >
        </van-field>
        <van-popup v-model="showPicTime" position="bottom">
          <van-datetime-picker
            type="datetime"
            title="选择完整时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onconfirmTime"
            @cancel="showPicTime = false"
          />
        </van-popup>
        <van-field name="uploader" label="图片上传:">
          <template #input>
            <ImgUpload ref="imgUploadRef" :max-count="9"></ImgUpload>
          </template>
        </van-field>
        <van-field
          v-model="typeInForm.remark"
          rows="2"
          type="textarea"
          label="备注："
          placeholder="请输入备注信息"
        />
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </van-form>
    </div>
    <!-- 搜索车牌号获取车辆信息弹窗区域 start -->
    <van-popup
      v-model="searchCarInfoPop"
      :closeable="false"
      :close-on-click-overlay="false"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <radiolist
        :arrData="carDataList"
        @closePopup="closePopup"
        @cloesIndo="cloesIndo"
      />
    </van-popup>
    <!-- 搜索车牌号获取车辆信息弹窗区域 end -->
  </div>
</template>

<script>
import { Toast } from "vant";
import { deleteCookie } from "../../ ../../utils/env";
import { encipherMent, encryptDecode } from "@/utils/encrypt";
import radiolist from "./components/radiolist.vue";
import ImgUpload from "./components/ImgUpload.vue";
export default {
  components: { radiolist, ImgUpload },
  data() {
    return {
      searchValue: "", //号码/编码
      searchType: "1", //编码类型
      typeInForm: {
        bulkTypeName: "", //大宗拆解物类型名称
        bulkDismantlingClassId: "", //大宗拆解物类型Id
        end_of_lifeVehiclesId: "", //进场编号
        num: "", //数量
        weight: "", //重量
        prime_cost: "", //成本单价
        dismantleStartTime: "", //拆解日期
        dismantlerName: "", //拆解人名称
        dismantler: "", //拆解人Id
        remark: "", //备注
      },
      minDate: new Date(), //最小可选时间
      maxDate: "", //最大可选时间
      dismantleTypeList: [], //拆解物类别列表
      dismantlePersonList: [], // 拆解人员列表
      dismantleTypePop: false, //大宗类型选择弹窗
      personPop: false, // 拆解人员弹窗
      searchCarInfoPop: false, // 车辆搜索结果弹窗
      showPicTime: false, // 拆解日期选择弹窗
      carDataList: [], // 车辆信息列表
      timer: null, // 定时器
      countType: "", // 拆解物类别数量单位
    };
  },
  created() {
    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() + 2); // 使用setFullYear方法设置两年后的年份
    this.getDismantleType(); //获取拆解物类别
    this.getDismantlePerson(); // 获取拆解人员
  },
  methods: {
    // 提交
    onSubmit() {
      if (this.$refs.imgUploadRef.imgUrlList?.length) {
        this.typeInForm.bulk_image = this.$refs.imgUploadRef.imgUrlList;
      }
      Toast({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });
      let data = encipherMent(JSON.stringify(this.typeInForm));
      let param = new URLSearchParams();
      param.append("value", data);
      this.$http
        .post("/index.php/index/bulk_Warehousing/casualAdd", param)
        .then((res) => {
          Toast.clear();
          let result = {};
          if (res.data.code == -1 || res.data.code == 9) {
            result = res.data;
          } else {
            result = JSON.parse(encryptDecode(res.data));
          }
          if (result.code == "0") {
            this.$toast.success("提交成功");
            this.timer = setTimeout(() => {
              this.$router.go("-1");
              this.resetFormValue();
            }, 800);
          } else {
            this.$toast.fail(result.msg);
          }
        });
    },
    // 清空表单
    resetFormValue() {
      for (const key in this.typeInForm) {
        this.typeInForm[key] = "";
      }
      this.$refs.imgUploadRef.emptyImgList();
      this.searchValue = "";
      this.searchType = "1";
    },

    //大宗类型选择确定
    onCheckedGoods(e) {
      this.dismantleTypePop = false;
      this.typeInForm.bulkTypeName = e.name;
      this.typeInForm.bulkDismantlingClassId = e.id;
      this.countType = e.countType;
    },
    // 拆解人选中确定
    onCheckedPerson(e) {
      this.personPop = false;
      this.typeInForm.dismantlerName = e.realName;
      this.typeInForm.dismantler = e.id;
    },
    // 拆解日期
    onconfirmTime(e) {
      this.typeInForm.dismantleStartTime = this.$moment(e).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.showPicTime = false;
    },
    // 编码/号码查询
    getCarInfo() {
      this.$http
        .post("/index.php/filter/vehiclesInfo", {
          searchValue: this.searchValue,
          searchType: this.searchType,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.length == 1) {
              this.typeInForm.end_of_lifeVehiclesId = res.data.data[0].id;
            } else if (res.data.data.length > 1) {
              this.carDataList = res.data.data;
              this.searchCarInfoPop = true;
            }
          } else {
            this.typeInForm.end_of_lifeVehiclesId = "";
            this.$toast.fail(res.data.msg);
          }
        });
    },
    // 获取拆解物类别
    async getDismantleType() {
      this.$http
        .post("/index.php/index/Simply", { type: "bulkDismantlingClass" })
        .then((res) => {
          if (res.data.code == 0) {
            this.dismantleTypeList = res.data.data;
          } else if (res.data.code == "-1") {
            this.$toast.fail(res.data.msg);
            deleteCookie("token");
            this.$router.push("/login");
          } else {
            this.$toast.fail(res.data.msg);
          }
        });
    },
    // 获取拆解人员
    async getDismantlePerson() {
      this.$http
        .post("/index.php/index/user/userList", { type: "bulkBreaker" })
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.dismantlePersonList = res.data.data;
          } else if (res.data.code == "-1") {
            this.$toast.fail(res.data.msg);
            deleteCookie("token");
            this.$router.push("/login");
          } else {
            this.$toast.fail(res.data.msg);
          }
        });
    },
    // 车辆信息弹窗选中车辆的数据
    cloesIndo(e) {
      this.typeInForm.end_of_lifeVehiclesId = e.id;
      this.searchCarInfoPop = false;
    },
    //关闭搜索出的车辆信息弹窗
    closePopup() {
      this.searchCarInfoPop = false;
    },

    // 返回上页
    previousPage() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    // 页面销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.add-box {
  width: 100vw;
  height: 100vh;
  .header {
    width: 100%;
    height: 50px;
    color: azure;
    background-color: cadetblue;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    z-index: 999;
    .back-img {
      margin-left: 10px;
      width: 28px;
      height: 28px;
      background-image: url(../../assets/u39.png);
      background-size: 100%;
    }
    .quit {
      margin-right: 10px;
    }
  }
  .search-box {
    padding-top: 60px;
    background-color: #f7f8fa;
    width: 100%;
    padding-left: 6%;
  }
  .form-box {
    width: 94%;
    height: calc(100vh - 120px);
    margin-left: 3%;
  }
  .list-box {
    width: 100%;
    padding-top: 106px;
    .list-item {
      width: 94%;
      border: 1px solid #c8cddb;
      margin-left: 3%;
      margin-bottom: 10px;
      border: 1px solid #eee;
      border-radius: 30px;
      background-color: #fff;
      position: relative;
      .item-box {
        width: 90%;
        margin: 20px;
        border-radius: 30px;
      }
    }
  }
}
.sticky {
  position: sticky;
  top: 0px;
}
.tabs-sticky {
  position: sticky;
  top: 50px;
  z-index: 999;
}
</style>
